import HttpClient from "./httpClient";

export interface Guide {
  id: number;
  description: string;
  platform: string | null;
  type: string | null;
  customer_id: number | null;
}

export interface Workflow {
  id: number;
  msp_id: number;
  workflow_name: string;
  args_json: any;
  created_by: string;
  created_at: string;
  updated_at: string;
  guides: Guide[];
  is_custom?: boolean;
  /** Set for custom workflows from workflow_step_definitions (e.g. User Onboarding / User Offboarding). */
  workflow_type?: string;
}

export interface WorkflowRun {
  run_id: string;
  workflow_id: number;
  run_key: string;
  workflow_name: string;
  msp_id: number;
  max_event_sequence: number;
  last_event_time: string;
  latest_status: "succeeded" | "failed" | "in_progress";
  latest_event: string;
  error_message: string | null;
  total_events: number;
}

export interface WorkflowRunEvent {
  id: number;
  workflow_id: number;
  run_id: string;
  event_sequence: number;
  event: string;
  status: "succeeded" | "failed" | "in_progress";
  error_message: string | null;
  event_time: string;
}

class WorkflowApi extends HttpClient {
  public getWorkflows = async (customerId?: number | null, ticketId?: string | null): Promise<Workflow[]> => {
    const params: Record<string, string> = {};
    if (customerId) {
      params.customer_id = customerId.toString();
    } else if (ticketId) {
      // Pass ticketId when customerId is missing so backend can look it up
      params.ticket_id = ticketId;
    }
    const response = await this.get(`/api/workflows`, undefined, params);
    return response;
  };

  public getWorkflowRuns = async (): Promise<WorkflowRun[]> => {
    const response = await this.get(`/api/workflows/runs`);
    return response;
  };

  public getWorkflowRunEvents = async (runId: string): Promise<WorkflowRunEvent[]> => {
    const response = await this.get(`/api/workflows/runs/${runId}/events`);
    return response;
  };
}

const workflowApi = new WorkflowApi();

export default workflowApi;

